<template>
  <div class="model-bd" :style="styleObj">
    <div class="cont-comp-loading" v-if="loading">
      <a-spin :spinning="loading"></a-spin>
    </div>
    <div class="widget-time" v-show="dateRang && dateRang.length > 0">
			<TagDateRange size="small" v-model="dateRang"  @change="onChange"></TagDateRange>
    </div>
    <v-chart :options="options" autoresize/>
  </div>
</template>

<script>
import moment from 'moment';
import TagDateRange from "@/components/TagDateRange";

export default {
  name: "WidgetFunnel",
  components: {},
  props: {
    value: Object,
    ispreview: Boolean
  },
  data() {
    return {
      options: {
        color: [],
        title: {
          text: "",
          textStyle: {
            color: "#fff"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}"
        },
        legend: {
          x: 'center',
          y: '92%',
          textStyle: {
            color: "#fff"
          }
        },
        series: [
          {
            name: "",
            type: "funnel",
            left: "center",
            width: "80%",
            //maxSize: '80%',
            sort: "descending",
            label: {
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}',
                textStyle: {
                  color: '#fff',
                  fontSize: 14,
                }
              },
              emphasis: {
                position: 'inside',
                formatter: '{b}: {c}'
              }
            },
            itemStyle: {
              normal: {
                opacity: 0.8,
                borderWidth: 0,
                shadowBlur: 0,
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                // borderColor: 'rgba(12, 13, 43, .9)',
                // shadowColor: 'rgba(0, 0, 0, .6)'
              }
            },
            data: []
          }
        ]
      },
      optionsStyle: {}, // 样式
      optionsData: {}, // 数据
      optionsSetup: {},
      // 时间组件
      dateRang: [],
      timeSelector: "",
      loading: false,
      flag: false
    };
  },
  components: {
    TagDateRange
  },
  inject: ["getDashboardDynamicData", "getFilterCondition"],
  computed: {
    dashbordData() {
      return this.getDashboardDynamicData()?.contextData || {}
    },
    styleObj() {
      return {
        position: this.ispreview ? "absolute" : "static",
        width: this.optionsStyle.width + "px",
        height: this.optionsStyle.height + "px",
        left: this.optionsStyle.left + "px",
        top: this.optionsStyle.top + "px",
        background: this.optionsSetup.background
      };
    }
  },
  watch: {
    value: {
      handler(val) {
        let flag = this.optionsData === val.data && !this.optionsData?.dynamicData?.chartProperties?.isVerified
        this.optionsStyle = val.position;
        this.optionsData = val.data;
        this.optionsSetup = val.setup;
        if(this.ispreview && this.isContCompDate(this.optionsData)) {
        }else {
          this.editorOptions(flag);
          this.editorDataSet();
        }
        // this.editorOptions();
      },
      deep: true
    }
  },
  created() {
    this.optionsStyle = this.value.position;
    this.optionsData = this.value.data;
    this.optionsSetup = this.value.setup;
    this.editorOptions();
  },
  methods: {
    filterSearch() {
      this.getEchartData(this.optionsData.dynamicData, this.optionsSetup);
    },
     onChange(val, timeSelector) {
      if(this.ispreview){
        const optionsSetup = this.optionsSetup;
        const optionsData = this.optionsData;
        const dataSet = this.optionsData.dynamicData.contextData;
        dataSet.dateRang.from = val[0];
        dataSet.dateRang.to = val[1];
        dataSet.dateRang.timeSelector = timeSelector;
        this.getEchartData(optionsData.dynamicData, optionsSetup);
      }
    },
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    // 修改图标options属性
    editorOptions(flag) {
      this.setEnding();
      this.setOptionsText();
      this.setOptionsTitle();
      this.setOptionsTooltip();
      this.setOptionsMargin();
      this.setOptionsLegend();
      this.setOptionsColor();
      !flag&&this.setOptionsData();
    },
    editorDataSet(){
      // 获取数据的配置项；
      const dataSet = this.optionsData.dynamicData.contextData;
      // 设置日期响应
      if(!!dataSet && dataSet.dateRang.from && dataSet.dateRang.to){
        let dateRang = [];
        dateRang[0] = dataSet.dateRang.from;
        dateRang[1] = dataSet.dateRang.to;
        this.$set(this.dateRang, 0, dateRang[0])
        this.$set(this.dateRang, 1, dateRang[1])
        this.timeSelector = dataSet.dateRang.timeSelector
      }else {
        this.dateRang = [];
        this.timeSelector = ''
      }
    },
    previewInit(data) {
      if(this.isContCompDate(this.optionsData)){
        // const that  = this;
        if(!this.flag){
          this.setPieFromResponse(data)
          this.flag = true;
        }
      }else {
        this.setPieFromResponse(data)
      }
    },
    setPieFromResponse(res) {
      this.renderingFn(res);
    },
    // 边距设置
    setOptionsMargin() {
      const optionsSetup = this.optionsSetup;
      // debugger;
      const grid = {
        left: optionsSetup.marginLeft || 24,
        right: optionsSetup.marginRight || 24,
        bottom: optionsSetup.marginBottom || 44,
        top: optionsSetup.marginTop || 76,
        containLabel: true,
      };
      this.options.grid = grid;
    },
    // 翻转
    setEnding() {
      const optionsSetup = this.optionsSetup;
      const series = this.options.series;
      if (optionsSetup.ending) {
        series[0].sort = "ascending";
      } else {
        series[0].sort = "descending";
      }
    },
    // 数值设置
    setOptionsText() {
      const optionsSetup = this.optionsSetup;
      const normal = {
        show: optionsSetup.isShow,
        position: 'inside',
        formatter: '{c}',
        textStyle: {
          color: optionsSetup.color,
          fontSize: optionsSetup.fontSize,
          fontWeight: optionsSetup.fontWeight,
        }
      }
      this.options.series[0].label['normal'] = normal;
    },
    // 标题修改
    setOptionsTitle() {
      const optionsSetup = this.optionsSetup;
      const title = {};
      title.text = optionsSetup.titleText;
      title.show = true;
      title.left = optionsSetup.textAlign || 'left';
      title.textStyle = {
        color: optionsSetup.textColor || "#13234C",
        fontSize: optionsSetup.textFontSize || 16,
        fontWeight: optionsSetup.textFontWeight || 400,
      };
      title.subtext = optionsSetup.subText;
      title.subtextStyle = {
        color: optionsSetup.subTextColor,
        fontWeight: optionsSetup.subTextFontWeight,
        fontSize: optionsSetup.subTextFontSize || 12,
      };
      title.padding = [16, 24, 8, 24];
      this.options.title = title;
    },
    // 提示语设置 tooltip
    setOptionsTooltip() {
      const optionsSetup = this.optionsSetup;
      const tooltip = {
        trigger: "axis",
        show: true,
        textStyle: {
          color: optionsSetup.lineColor || '#FFF',
          fontSize: optionsSetup.tipFontSize || '14px'
        },
        formatter: (params) => {
          return `${params.data.oname}: ${params.data.value}${params.data.symbol}`
        }
      };
      this.options.tooltip = tooltip;
    },
    // 图例操作 legend
    setOptionsLegend() {
      const optionsSetup = this.optionsSetup;
      const legend = this.options.legend || true;
      // legend.show = optionsSetup.isShowLegend;
      // legend.left = optionsSetup.lateralPosition;
      // legend.right = optionsSetup.lateralPosition;
      // legend.top = optionsSetup.longitudinalPosition;
      // legend.bottom =
      //   optionsSetup.longitudinalPosition;
      legend.show = optionsSetup.isShowLegend  || true;
      legend.left = optionsSetup.lateralPosition == "left" ? 0 : "right";
      legend.right = optionsSetup.lateralPosition == "right" ? 0 : "auto";
      legend.top = optionsSetup.longitudinalPosition == "bottom" ? 30 : "bottom";
      legend.bottom =
        optionsSetup.longitudinalPosition == "bottom" ? 30 : 30;
      legend.orient = optionsSetup.layoutFront || 'horizontal';
      legend.padding= [ 0, 24, 12, 24]
      legend.textStyle = {
        color: optionsSetup.lengedColor || "#677392",
        fontSize: optionsSetup.lengedFontSize
      };
      legend.itemWidth = optionsSetup.lengedWidth || 12;
    },
    // 图例颜色修改
    setOptionsColor() {
      const optionsSetup = this.optionsSetup;
      const defaultColor =  [
        { color: "#8DAEFF" },
        { color: "#4278FF" },
        { color: "#55D2DE" },
        { color: "#3BD351" },
          { color: "#89E496" },
        { color: "#87cefa" },
        { color: "#FBBC00" },
        { color: "#FCD666" },
        { color: "#E96469" },
          { color: "#F1A2A5" },
        { color: "#C369EA" },
        { color: "#DBA5F2" },
      ];
      const customColor = optionsSetup.customColor ? optionsSetup.customColor : defaultColor;
      // const customColor = optionsSetup.customColor;
      if (!customColor) return;
      const arrColor = [];
      for (let i = 0; i < customColor.length; i++) {
        arrColor.push(customColor[i].color);
      }
      this.options.color = arrColor;
      this.options = Object.assign({}, this.options);
    },
    setOptionsData() {
      const optionsData = this.optionsData; // 数据类型 静态 or 动态
      if(optionsData.dataType == "staticData"){
          this.staticDataFn(optionsData.staticData);
        }else if(optionsData.dataType == "dynamicData"){
          let oneTime = this.$once(this.staticDataFn);
          oneTime(optionsData.staticData);
          // debugger;
          // 如果是新的数据，则还是利用旧数据进行渲染；
          if(optionsData.dynamicData && optionsData.dynamicData.contextData){
            this.dynamicDataFn(optionsData.dynamicData, optionsData.refreshTime)
          }          
        }
      // optionsData.dataType == "staticData"
      //   ? this.staticDataFn(optionsData.staticData)
      //   : this.dynamicDataFn(optionsData.dynamicData, optionsData.refreshTime);
    },
    staticDataFn(val) {
      const staticData = typeof val == "string" ? JSON.parse(val) : val;
      for (const key in this.options.series) {
        if (this.options.series[key].type == "funnel") {
          this.options.series[key].data = staticData;
        }
      }
    },
    dynamicDataFn(val, refreshTime) {
      if (this.ispreview) {
        this.editorDataSet();
        // this.getEchartData(val);
      } else {
        if (!val  || !val.chartProperties || val.chartProperties.isVerified === false) return;
        this.getEchartData(val);
      }
      
    },
    getEchartData(val) {
        this.loading = true;
        const data = this.queryEchartsData(val.contextData,val.params,  val.chartProperties);
        data.then(res => {
          this.loading = false;
          this.renderingFn(res);
        }).catch(err => {
          this.loading = false;
        });
    },
    getFunnelChartData(data){
      console.log(data, 'getFunnelChartData')
      const arr = [];
      if (data && data.result && data.result.length >0 && data.fields) {
        data.result.forEach((item, index) => {
          let o = data.fields?data.fields[index]:{}
          let s = o.fieldUnit?.symbol || ''
          const obj = {};
          obj.name =  (o.name || item.name) + (s?`(${s})`:'')
          obj.oname =  o.name || item.name
          obj.value = item.value;
          obj.field = item.field;
          obj.symbol = s;
          arr.push(obj);
        });
      }
      return arr;
    },
    renderingFn(res) {
      let val = this.getFunnelChartData(res);
      console.log(val);
      const that  = this;
      for (const key in this.options.series) {
        console.log(key, this.options, 'this.options-key')
        if (this.options.series[key].type == "funnel") {
          this.options.series[key].data = val;
          this.options.series[key].top = 64;
          this.options.series[key].itemStyle ={
            normal: { 
              label: {
                formatter: function(params) {
                  const value = params.value;
                  return `${that.$getThousandths(value)}(${params.percent}%)`;
                }
              }
            }
          };
          // this.options.series[key].center = ['35%','20%'];
        }
      }
      // for (const key in this.options.series) {
      //   if (this.options.series[key].type == "funnel") {
      //     this.options.series[key].data = val;
      //   }
      // }
    }
  }
};
</script>

<style scoped lang="less">
.echarts {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
